import { motion } from "framer-motion";
import { Users, Layers, UserPlus } from "lucide-react";

const Organigramme = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#1E3D1A]">
        <div className="absolute inset-0 bg-[url('/images/carrousel3.webp')] opacity-50" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
              STRUCTURATION ET ORGANIGRAMME DE PMN
            </h1>
            <p className="text-xl text-white/90">
              Découvrez la structure organisationnelle du Projet Mobilier National
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Introduction Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="bg-white rounded-2xl p-8 shadow-lg mb-16"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-[#1E3D1A] p-3 rounded-lg text-white">
                  <Users className="w-8 h-8" />
                </div>
                <h2 className="text-2xl font-bold text-[#1E3D1A]">
                  Équipe de Gestion
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed text-justify">
                L'équipe de gestion inclut, outre le coordonnateur et son adjoint, un personnel permanent cadre et de soutien constitué comme suit :
              </p>
            </motion.div>

            {/* Organigramme Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-white rounded-2xl p-8 shadow-lg mb-16"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-[#1E3D1A] p-3 rounded-lg text-white">
                  <Layers className="w-8 h-8" />
                </div>
                <h2 className="text-2xl font-bold text-[#1E3D1A]">
                  Organigramme
                </h2>
              </div>
              <div className="relative w-full h-[600px] rounded-xl overflow-hidden shadow-lg">
                <img
                  src="/images/organigramm.jpg"
                  alt="Organigramme PMN"
                  className="w-full h-full object-contain"
                />
              </div>
            </motion.div>

            {/* Team Structure Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="bg-white rounded-2xl p-8 shadow-lg"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-[#1E3D1A] p-3 rounded-lg text-white">
                  <UserPlus className="w-8 h-8" />
                </div>
                <h2 className="text-2xl font-bold text-[#1E3D1A]">
                  Structure de l'Équipe
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-xl font-semibold text-[#1E3D1A] mb-4">
                    Personnel Cadre
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Coordonnateur</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Adjoint au Coordonnateur</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Chefs de Service</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="text-xl font-semibold text-[#1E3D1A] mb-4">
                    Personnel de Soutien
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Assistants</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Secrétaires</span>
                    </li>
                    <li className="flex items-center space-x-3">
                      <div className="w-2 h-2 rounded-full bg-[#1E3D1A]" />
                      <span className="text-gray-600">Techniciens</span>
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Organigramme;
